import { render, staticRenderFns } from "./accountPage.vue?vue&type=template&id=11d47aa2&scoped=true"
import script from "./accountPage.vue?vue&type=script&lang=js"
export * from "./accountPage.vue?vue&type=script&lang=js"
import style0 from "./accountPage.vue?vue&type=style&index=0&id=11d47aa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d47aa2",
  null
  
)

export default component.exports